import 'css-chunksrc/client/scenes/resourceDetailsConfiguration/form/columns/form/styles.scss';export default {
  "input": "_input_oucrp_1",
  "listRoot": "_listRoot_oucrp_14",
  "list": "_list_oucrp_14",
  "item": "_item_oucrp_30",
  "icon": "_icon_oucrp_43",
  "name": "_name_oucrp_51"
};